
import { useLocation } from "react-router-dom";
import { Logo } from "./top-bar/Logo";
import { Navigation } from "./top-bar/Navigation";
import { AuthSection } from "./top-bar/AuthSection";
import { MobileMenu } from "./top-bar/MobileMenu";
import { useTopBarAuth } from "@/hooks/useTopBarAuth";
import { AuthErrorBoundary } from "./auth/AuthErrorBoundary";
import { AuthLoader } from "./auth/AuthLoader";

const TopBar = () => {
  const location = useLocation();
  const { user, userRole, loading, error, handleLogout, getDashboardLink } = useTopBarAuth();

  // Check if we're in the guest layout
  const isGuestLayout = location.pathname.startsWith('/guest');

  if (loading) {
    return (
      <div className="border-b bg-white">
        <div className="flex justify-between items-center h-16 px-4">
          <Logo />
          <AuthLoader />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="border-b bg-white">
        <div className="flex justify-between items-center h-16 px-4">
          <Logo />
          <AuthErrorBoundary>
            <div className="text-sm text-red-600">Auth Error</div>
          </AuthErrorBoundary>
        </div>
      </div>
    );
  }

  return (
    <AuthErrorBoundary>
      <div className="border-b bg-white">
        <div className="flex justify-between items-center h-16 px-4">
          <div className="flex items-center space-x-4">
            <Logo />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            <Navigation user={user} userRole={userRole} />
            <AuthSection 
              user={user}
              getDashboardLink={getDashboardLink}
              handleLogout={handleLogout}
            />
          </div>

          {/* Mobile Navigation - Only show if not in guest layout */}
          {!isGuestLayout && (
            <MobileMenu 
              user={user}
              userRole={userRole}
              getDashboardLink={getDashboardLink}
              handleLogout={handleLogout}
            />
          )}
        </div>
      </div>
    </AuthErrorBoundary>
  );
};

export default TopBar;
